import { keepPreviousData, useQuery, type UseQueryResult } from "@tanstack/react-query";
import { type CompanyClassList, type EmployerGroup, type EmployerPage } from "@vidario/domain";

import { useVidarioClient } from "../client";
import { type UnassignedQuery } from "../endpoints";
import { queryKeys } from "../queryKeys";

/** Admin-only (#139): every company class with its size, plus the to-do count. */
export function useCompanyClasses(): UseQueryResult<CompanyClassList> {
  const client = useVidarioClient();
  return useQuery({ queryKey: queryKeys.companyClasses(), queryFn: () => client.getCompanyClasses() });
}

/** Admin-only: the companies of one class. */
export function useClassCompanies(classId: number | null): UseQueryResult<EmployerGroup[]> {
  const client = useVidarioClient();
  return useQuery({
    queryKey: queryKeys.classCompanies(classId ?? -1),
    queryFn: () => client.getClassCompanies(classId ?? -1),
    enabled: classId !== null,
  });
}

/** Admin-only: one page of the to-do list. Keeps the previous page on screen while the next loads. */
export function useUnassignedCompanies(query: UnassignedQuery): UseQueryResult<EmployerPage> {
  const client = useVidarioClient();
  return useQuery({
    queryKey: queryKeys.unassignedCompanies(query),
    queryFn: () => client.getUnassignedCompanies(query),
    placeholderData: keepPreviousData,
  });
}
